<template>
  <div class="commissionWithdrawal_warpper" :style="commissionWithdrawal_warpper_style">
    <nav-bar titleText="提现" titleWeight="bold" @goBack="goBack"></nav-bar>

    <div class="contentBox">
      <div class="bankBody">
        <van-row class="bank_row">
          <div class="bank_title">
            <img :src="!this.member_avator ? agentimg : this.member_avator" />
          </div>
          <div class="bank_account">{{ blankInfo }}</div>
          <!-- <div class="bank_updateCard">
            <img src="../../../assets/debtor/right-arrow.png" alt="">
          </div> -->
        </van-row>
      </div>
      <div class="amount_title">提现金额</div>
      <div class="amountBody">

        <div class="amount_input">
          <span class="money_logo">¥</span>
          <span class="money-num">{{withdrawal_amount}}</span>
          <span class="withdrawal-all-btn" @click="handleAllWithdrawal">全部提现</span>
        </div>
        <div class="amount-item" v-show="withdrawal_amount > 0">
          <div class="item-left">手续费({{(realwithdrawalamountInfo.withdrawal_proportion * 100 ).toFixed(2)+ '%'}})</div>
          <div class="item-right">￥{{realwithdrawalamountInfo.withdrawal_fee}}</div>
        </div>
        <div class="amount-item actual-item" v-show="withdrawal_amount > 0">
          <div class="item-left">实际到账金额</div>
          <div class="item-right">￥{{realwithdrawal_amount}}</div>
        </div>
        <div class="uploadBox" :style="uploadBoxStyle">
          <!--upload_title 上传凭证-->
          <van-uploader v-model="fileList" multiple :max-count="8" :preview-size="img_height" @oversize="onOversize"
            @delete="deleteFile1" :after-read="afterRead" :before-read="beforeRead">
            <div class="box" :style="boxStyle">
              <div class="icon">+</div>
              <div class="title">上传发票</div>
            </div>
          </van-uploader>
        </div>
        <!-- <div class="note" id="header"> -->
          <!-- <div>
            <div class="eye" @click="showPassword = !showPassword">
              <van-icon v-if="showPassword" name="eye" size="30px" color="#f9591b" />
              <van-icon v-if="! showPassword" name="closed-eye" size="30px" color="#f9591b" />
            </div>
            <input 
              ref="password"
              :type="passType" 
              class="password" 
              v-model="password" 
              placeholder="请输入支付密码"
              @focus="handleFocus(password)"
              @blur="handleBlur"
            />
          </div> -->
          <!-- <input ref="remark" type="text" class="remark" v-model="remark" placeholder="请输入备注信息"
            @focus="handleFocus(remark)" @blur="handleBlur" />
        </div> -->
        <div class="withdrawal-list">
          <div>佣金订单列表</div>
          <van-checkbox-group v-model="allowanceresult" @change="allowanceChange" ref="allowanceReflist">
            <div v-for="(item,index) in allowanceList" :key="index">
              <div class="allowance-title">{{item.created_at.split(' ')[0].split('-')[1]}}月份津贴
                <span>{{item.allowance_amount}}</span>
                <div class="checkout-right">
                  <van-checkbox :name="item" />
                </div>
              </div>
            </div>
          </van-checkbox-group>
          <div class="allowance-list">
            <van-checkbox-group v-model="orderresult" @change="orderListChange" ref="orderReflist">
              <div class="allowance-item" v-for="(item,index) in orderList" :key="index">
                <div class="allowance-item-left">
                  <div class="allow-left-top">订单{{item.order_sn}}</div>
                  <div class="allow-left-bottom"><span>债务人：{{item.debtor_name }} </span> <span>
                      债权人：{{item.creditor_name}}</span></div>
                </div>
                <div class="allowance-item-right">佣金 {{item.agent_profit}}</div>
                <div class="checkout-div">
                  <van-checkbox :name="item" ref="checkboxes" />
                </div>
              </div>
            </van-checkbox-group>
          </div>
        </div>
        <div class="operation" :style="completeStyle">
          <!-- <van-button type="primary" :disabled="isDisabled" class="withdrawal_btn" @click="submit">提交申请</van-button> -->
          <van-button type="primary" class="withdrawal_btn" @click="preSubmit">提交申请</van-button>
        </div>
      </div>
    </div>
    <div class="loading" v-if="loading">
      <img src="../../../assets/common/loading.gif" />
    </div>

    <div class="dialog">
      <van-dialog v-model="showDialog" title="提示" message="您还未绑定银行卡" confirm-button-text="去绑卡"
        confirm-button-color="#F9591B" cancel-button-text="取消" cancel-button-color="#999999" @confirm="confirmEvent"
        @cancel="cancelEvent" show-cancel-button overlay lock-scroll>
      </van-dialog>
    </div>

    <van-popup v-model="showPasswordBox" position="bottom">
      <div class="passwordBox-title">
        <div class="center">
          <img src="../../../assets/debtor/eye_open.png" v-if="! passwordMask" @click="passwordMask = ! passwordMask"
            alt="">
          <img src="../../../assets/debtor/eye_closed.png" v-if="passwordMask" @click="passwordMask = ! passwordMask"
            alt="">
          <p>验证支付密码</p>
        </div>
        <img class="icon" src="../../../assets/debtor/closed_keybord.png" alt="" @click="showPasswordBox = false">
      </div>

      <van-password-input :value="passwordValue" :focused="showKeyboard" :gutter="10" :mask="passwordMask"
        @focus="showKeyboard = true" @password-input-margin="10" />

      <!-- TODO: handle this click event -->
      <div class="forget_paasword" @click="forgetPro">忘记密码</div>

      <van-number-keyboard v-model="passwordValue" :show="showKeyboard" @blur="show = false" @input="keyboardInput"
        @show="setBorderOfFirstPaasword" @delete="keyboardDelete">
        <template v-slot:delete>
          <img class="delete" src="../../../assets/debtor/delete.png" alt="">
        </template>
      </van-number-keyboard>

    </van-popup>

  </div>
</template>
<script>
  import navBar from "../components/navBar";
  // import {
  //   uploadMixin
  // } from "../mixin"
  export default {
    name: "commissionWithdrawal",
    data() {
      return {
        amount: "", //当前佣金
        blankInfo: "",
        id: "",
        show: false,
        password: '',
        showPassword: false,
        client: 0,
        remark: "",
        fileList: [],
        fileList1: [],
        fileNameMap: {},
        upload_file: "",
        img_height: '100px',
        member_avator: '',
        commissionWithdrawal_warpper_style: {
          height: '100%'
        },
        toast: '',
        completeStyle: {},
        loading: false,
        isDisabled: true,
        timeId: 0,
        agentimg: require('@/assets/debtor/actver.png'),
        showDialog: false,
        showPasswordBox: false,
        passwordValue: '',
        showKeyboard: true,
        passwordMask: true,
        checked: false,
        orderList: [],
        allowanceList: [],
        allowanceList_money: 0,
        orderList_money: 0,
        withdrawal_amount: "", //输入金额
        withdrawal_static_amount: 0,
        realwithdrawalamountInfo: {},
        realwithdrawal_amount: 0,
        allowanceresult: [],
        orderresult: [],
        toggleAllStatus: true,
      };
    },
    computed: {
      uploadBoxStyle() {
        return {
          'min-height': this.img_height
        }
      },
      boxStyle() {
        return {
          width: this.img_height,
          height: this.img_height
        }
      },
      passType() {
        return this.showPassword ? 'number' : 'password'
      },
    },
    created() {
      if (!this.isIphoneX()) {
        this.completeStyle = {
          height: '70px'
        }
      }
      this.getComission()
      this.getBankInfo()
      this.getWithdrawalList()
    },
    mounted() {
      // /3 一行三张  
      this.img_height = ((document.body.clientWidth - 39) / 3 - 8 - 1) + 'px'
      this.deductionUA()
    },
    destroyed() {
      clearInterval(this.timeId)
      this.timeId = null
    },
    components: {
      navBar,
    },
    // mixins: [uploadMixin],
    methods: {
      onOversize(file) {
        const fileSize = Math.floor(parseInt(file.size) / 1024)
        this.$toast(`文件大小(${fileSize}) 不能超过 5000kb`);
      },
      _afterRead(file, type, fileList, fileList1, fileNameMap) {
        // 同时上传多张图片时file是array
        if (Array.isArray(file)) {
          file.forEach(item => {
            this.__afterRead(item, type, fileList, fileList1, fileNameMap)
          })
          return
        }
        this.__afterRead(file, type, fileList, fileList1, fileNameMap)
      },
      async __afterRead(file, type, fileList, fileList1, fileNameMap) {
        try {
          const token = await this.$api.post('member/member/qiniu/auth', {
            "disk": "qualification"
          })
          let formData = new FormData()
          formData.append('token', token.token)
          formData.append('file', file.file)
          formData.append('key', file.file.name)
          const res = await this.$api.post("https://up-z0.qiniup.com", formData)
          fileList1.push(res.url + '/' + res.key)
          // 记录file name 对应关系，用于删除时同步删除fileList1里的内容
          fileNameMap[file.file.name] = res.url + '/' + res.key
        } catch (error) {
          // 清除预览
          for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].file.name === file.file.name) {
              fileList.splice(i, 1)
              break
            }
          }
          this.$toast('图片上传失败，请重新上传')
        }
      },
      // fix: 修复部分机型取消上传还是会暂时空白图片
      beforeRead(file) {
        if (!file.size) {
          return false
        }
        return true
      },
      deleteFile(file, fileList1, fileNameMap) {
        for (let i = 0; i < fileList1.length; i++) {
          if (fileList1[i] === fileNameMap[file.file.name]) {
            fileList1.splice(i, 1)
            fileNameMap[file.file.name] = undefined
            break
          }
        }
      },
      forgetPro() {
        const paramIos = {
          // routePath: '/mine/setting/account/change_trade_password_IdAuthention'
          routePath: 'xblife://mine/setting/account/change_trade_password_IdAuthention'
        }
        const paramAndroid = {
          // routePath: 'mine/setting/account/modify_identity'
          routePath: 'xblife://mine/setting/account/modify_identity'
        }
        this.params(JSON.stringify(paramIos), JSON.stringify(paramAndroid), 'toOriginal')
      },
      afterRead(file) {
        this._afterRead(file, 'voucher', this.fileList, this.fileList1, this.fileNameMap)
      },
      deleteFile1(file) {
        this.deleteFile(file, this.fileList1, this.fileNameMap)
      },
      deductionUA() {
        const ua = navigator.userAgent.toLowerCase();
        if (/iphone|ipad|ipod/.test(ua)) {
          this.client = 11;
        } else if (/android/.test(ua)) {
          this.client = 10;
        }
      },

      keyboardInput(key) {
        // 必须使用nextTick，否则键盘输入时，密码框还没有值
        this.$nextTick(() => {
          const list = document.querySelector('.van-password-input__security').children
          for (let i = 0; i < list.length; i++) {
            // 找到当前聚焦的密码格子
            if (list[i].children.length >= 2 && list[i].children[1].className == 'van-password-input__cursor') {
              list[i].style.border = '1px solid #fc740c'
              continue
            }
            // if (list[i].children.length)
            list[i].style.border = '1px solid #E5E5E5'
          }

          if (this.passwordValue.length >= 6) {
            this.submit()
          }

        })
      },
      setBorderOfFirstPaasword() {
        this.$nextTick(() => {
          const list = document.querySelector('.van-password-input__security').children
          for (let i = 0; i < list.length - 1; i++) {
            list[i].style.border = '1px solid #E5E5E5'
          }
          list[0].style.border = '1px solid #fc740c'
        })
      },

      keyboardDelete() {
        this.$nextTick(() => {
          const list = document.querySelector('.van-password-input__security').children
          for (let i = 0; i < list.length; i++) {
            // 找到当前聚焦的密码格子
            if (list[i].children.length >= 2 && list[i].children[1].className == 'van-password-input__cursor') {
              list[i].style.border = '1px solid #fc740c'
              continue
            }
            list[i].style.border = '1px solid #E5E5E5'
          }
        })
      },
      handleFocus(e) {
        // TODO 没有查到怎么获取手机系统键盘高度 只能写死200px？ 看原生能不能适配键盘弹起会遮挡的问题
        // if (this.client === 10) {
        //   setTimeout(() => {
        //     this.commissionWithdrawal_warpper_style = {height: 'calc(100% - 200px)'}
        //     this.completeStyle ={bottom: '200px'}
        //   },100)
        // }
      },
      handleBlur(e) {
        if (this.client === 10) {
          setTimeout(() => {
            this.commissionWithdrawal_warpper_style = {
              height: '100%'
            }
            this.completeStyle = {
              bottom: '0'
            }
          }, 100)
        }
      },
      onChange() {
        if (!this.value) {
          this.toast = ''
          this.isDisabled = true
          return
        }
        if (/^0[0-9]+/.test(this.value)) {
          this.value = this.value.slice(1)
          this.onChange()
        }
        if (parseFloat(this.value) <= 0) {
          this.isDisabled = true
          return
        }
        if (/\.[0-9][0-9]./.test(this.value)) {
          this.value = this.value.slice(0, -1)
          this.$toast('最多输入两位小数')
          this.onChange()
        }
        const balance = (parseFloat(this.amount) - parseFloat(this.value)).toFixed(2)
        if (balance < 0) {
          this.toast = '提现金额大于当前佣金'
          this.isDisabled = true
        }
        if (balance > 0) {
          this.toast = `剩余${balance}元`
          this.isDisabled = false
        }
        if (balance == 0) {
          this.toast = ''
          this.isDisabled = false
        }
      },
      getComission() {
        this.$api.post('/finance/member/account/info', {
            id: this.$route.query.id
          })
          .then(data => {
            this.amount = data.balance
          })
      },

      confirmEvent() {
        // TODO 绑卡 跳原生参数
        const param = {
          account_id: this.$route.query.id
        }
        this.params(
          JSON.stringify(param),
          JSON.stringify(param),
          "debtBindingBankCard"
        );
      },
      cancelEvent() {
        this.showDialog = false
        this.$router.go(-1)
      },
      getBankInfo() {
        this.$api.post('/debt/member/agent/isbank')
          .then(data => {
            let lastNumber = data.accountNo
            this.member_avator = data.member_avator
            if (/^\d+$/.test(lastNumber)) {
              // 全数字 银行卡号 取最后4位
              lastNumber = `尾号${lastNumber.slice(-4)}`
            }
            if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(lastNumber)) {
              // TODO
              // 邮箱  说明是支付宝？ 这种该怎么处理？ 这里暂时取前6位 + ***
              lastNumber = lastNumber.slice(0, 6) + '***'
            }
            this.blankInfo = `${data.channelName} ${lastNumber}`
            this.id = data.id
          })
          .catch(error => {
            if (error.code == 995) {
              this.showDialog = true
            }
          })
      },
      preSubmit() {
        // 数字，可以为小数
        if (!/^[0-9]*\.*[0-9]+$/.test(this.withdrawal_amount) || this.withdrawal_amount * 1 == 0) {
          return this.$toast('请输入正确的提现金额')
        }
        if (this.fileList.length === 0) {
          return this.$toast('请上传打款凭证图片')
        }
        // // 不为空
        // if (!/^[^\s]+$/.test(this.remark)) {
        //   return this.$toast('请输入备注信息')
        // }

        this.showPasswordBox = true
        this.setBorderOfFirstPaasword()
      },
      async submit() {

        // if (this.fileList.length !== this.fileList1.length) {
        //   return this.$toast('请等待打款凭证图片上传完毕')
        // }
        const orderIdList = this.orderresult.map((item) => {
          return item.id
        })
        const allowanceIdList = this.allowanceresult.map((item) => {
          return item.id
        })
        this.loading = true
        if (this.timeId) {
          clearInterval(this.timeId)
          this.timeId = null
        }
        this.timeId = setInterval(() => {
          if (this.fileList.length === this.fileList1.length) {
            clearInterval(this.timeId)
            this.timeId = null
            // const pwd = await this.$api.post('/debt/member/agent/contract')
            const param = {
              tradersPassword: this.passwordValue,
              invoice: this.fileList1, //类型：String  必有字段  备注：发票凭证
              // remark: this.remark, //类型：String  必有字段  备注：备注
              "withdrawal_amount": this.withdrawal_amount, //类型：Number  必有字段  备注：提现金额
              "withdrawal_amount_order": { //类型：Object  必有字段  备注：所选解债订单和津贴
                "list": orderIdList, //类型：Array  必有字段  备注：解债订单
                "allowance": allowanceIdList
              }
            }
            this.$api.post('/debt/member/withdrawal/withdrawal/apply', param)
              .then(res => {
                this.$router.push({
                  path: '/agent/withdrawalProcess',
                  query: {
                    id: res.id,
                  }
                })
              })
              .catch(err => {
                err.message && this.$toast(err.message)
              })
              .finally(() => {
                this.loading = false
                this.passwordValue = ''
                this.setBorderOfFirstPaasword()
              })
          }
        }, 200)
      },
      getWithdrawalList() {
        this.$api.post('/debt/member/withdrawal/withdrawal/list', {
          agent_idid: this.$route.query.id
        }).then(res => {
          this.orderList = res.list.filter((item, index) => {
            return item.is_withdrawal != 1
          })
          this.allowanceList = res.allowance.filter((item, index) => {
            return item.is_withdrawal != 1
          })
        })
      },
      getwithdrawal_proportion() {
        this.$api.post('/debt/member/withdrawal/withdrawal/info', {
          withdrawal_amount: this.withdrawal_amount
        }).then(res => {
          this.realwithdrawalamountInfo = res
          this.realwithdrawal_amount = res.withdrawal_amount
        })
      },
      async handleAllWithdrawal() {
        this.checked = true
        this.toggleAllStatus = false
        await this.$refs.orderReflist.toggleAll(true);
        await this.$refs.allowanceReflist.toggleAll(true);
        this.toggleAllStatus = true
      },
      allowanceChange(list) {
        this.allowanceList_money = 0
        for (let i in list) {
          this.allowanceList_money += list[i].allowance_amount * 1
        }
        this.withdrawal_amount = (this.allowanceList_money + this.orderList_money).toFixed(2)
        this.getwithdrawal_proportion()
      },
      orderListChange(list) {
        this.orderList_money = 0
        for (let i in list) {
          this.orderList_money += list[i].agent_profit * 1
        }
        this.withdrawal_amount = (this.allowanceList_money + this.orderList_money).toFixed(2)
        if (!this.toggleAllStatus) return
        this.getwithdrawal_proportion()
      },
      goBack() {
        this.$router.go(-1);
      },
    },
  };
</script>
<style lang="less">
  .commissionWithdrawal_warpper {
    padding-top: 88px;
    padding-bottom: 100px;
    box-sizing: border-box;
    background-color: #fff;
    height: 100%;
    color: #333;
    font-size: 14px;
    transition: height 0.1s linear;
    overflow-x: hidden;
    overflow-y: auto;

    // .navbar {
    //   margin: 24px 5px 0 5px;
    // }
    .contentBox {
      padding-top: 12px;
      background-color: #f5f6f7;

      .bankBody {
        background: #fff;
        margin: 0 0 12px;
        padding: 17px 12px;
      }

      .bank_row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
      }

      .bank_title {
        width: 29px;
        height: 29px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 25px;
        }
      }

      .bank_account {
        width: 100%;
        position: absolute;
        left: 40px;
        font-size: 15px;
        line-height: 24px;
      }

      .bank_updateCard {
        position: absolute;
        right: 0;

        img {
          width: 16px;
          height: 16px;
        }
      }

      .amountBody {
        background: #fff;
        padding: 0 12px 21px;
        overflow: hidden;
      }

      .amount_title {
        line-height: 24px;
        font-size: 15px;
        padding: 0 0 20px 10px;
      }

      .amount_input {
        margin: 10px 0;
        position: relative;
        padding-bottom: 10px;
        border-bottom: 1px solid #eaeaea;

        .money_logo {
          width: 20px;
          font-size: 30px;
        }

        .money-num {
          font-size: 30px;
          margin-left: 10px;
        }

        .withdrawal-all-btn {
          float: right;
          text-align: right;
          color: #f9591b;
          font-size: 15px;
          line-height: 34px;
        }
      }

      .amount-item {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        color: #ccc;

        .item-left {
          flex: 1;
        }

        .item-right {
          flex: 1;
          text-align: right;
        }
      }

      .actual-item {
        color: #000;
        padding-bottom: 10px;
        border-bottom: 1px solid #eaeaea;
      }

      .amount_col {
        color: #999;
        font-size: 15px;
        line-height: 24px;
      }

      .all_withdrawal_col {
        text-align: right;
        color: #f9591b;
        font-size: 15px;
        line-height: 24px;
      }

      .uploadBox {

        // min-height: 100px;
        .box {
          // width: 100px;
          // height: 100px;
          border: 1px dashed #dedede;
          box-sizing: border-box;

          .icon {
            text-align: center;
            color: #999999;
            height: 21px;
            line-height: 21px;
            margin: 27px 0 9px;
            font-size: 35px;
          }

          .title {
            text-align: center;
            font-size: 13px;
            height: 21px;
            line-height: 21px;
            color: #555555;
          }
        }
      }

      .note {
        margin: 15px 0 0;
        position: relative;

        .password {
          background: #f5f6f7;
          width: 100%;
          box-sizing: border-box;
          line-height: 26px;
          padding: 12px 15px;
          margin: 0 0 15px;
          border-radius: 2px;
          // color: #ccc;
          border: 1px solid #eee;
          font-size: 16px;
          letter-spacing: 2px;
        }

        .remark {
          background: #f5f6f7;
          width: 100%;
          box-sizing: border-box;
          line-height: 26px;
          padding: 12px 15px;
          border-radius: 2px;
          color: #ccc;
          border: 1px solid #eee;
          font-size: 16px;
          // letter-spacing:5px;
        }

        .eye {
          position: absolute;
          top: 11px;
          right: 13px;
        }
      }

      .van-field__control {
        font-size: 30px;
        font-weight: 600;
      }

      .van-field__body {
        input {
          text-indent: 26px;
        }
      }

      .amount_current_row {
        margin-bottom: 15px;
      }

      .van-field__error-message {
        color: #f9591b;
      }

      // .van-uploader__preview-image {
      //   // width: 100%;
      //   // height: 100%;
      // }
      .van-uploader__preview {
        margin: 0 10px 10px 0;

        .van-uploader__preview-delete {
          z-index: 999;
        }
      }

      .van-key--blue {
        font-weight: 600;
        color: #fff;
        background-color: #fc740c;
      }

      .withdrawal-list {
        margin-top: 20px;

        .allowance-title {
          margin: 10px 0;
          padding-bottom: 10px;
          text-indent: 10px;
          border-bottom: 1px solid #eaeaea;

          .checkout-right {
            float: right;

            .van-icon-success::before {
              margin-left: -20px;
            }
          }
        }

        .allowance-list {
          padding-left: 20px;

          .allowance-item {
            border-bottom: 1px solid #eaeaea;
            display: flex;
            width: 100%;
            padding-bottom: 10px;

            .allowance-item-left {
              flex: 1;
              font-size: 14px;

              .allow-left-top {
                margin: 5px 0;

              }

              .allow-left-bottom {
                color: #ccc;

                span {
                  &:last-child {
                    white-space: nowrap;
                  }
                }
              }
            }

            .allowance-item-right {
              width: 100px;
              position: relative;
              top: 15px;
            }

            .checkout-div {
              width: auto;
              position: relative;
              top: 15px;
              float: right;
            }
          }
        }
      }

      .operation {
        background-color: #fff;
        width: 100%;
        height: 88px;
        position: fixed;
        bottom: 0;
        left: 50%;
        transform: translate(-50%);
      }

      .withdrawal_btn {
        background-color: #fc740c;
        color: #fff;
        border: none;
        width: calc(100% - 30px);
        margin: 0 auto;
        height: 50px;
        font-size: 17px;
        display: block;
        border-radius: 10px;
        line-height: 50px;
        font-weight: 600;
      }
    }

    .loading {
      text-align: center;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 9999;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);

      img {
        width: 35%;
        margin-top: 65%;
      }
    }

    .dialog {
      .van-dialog {
        .van-dialog__header {
          font-size: 18px;
          font-weight: bold;
          padding-top: 20px;
          line-height: 25px;
          height: 25px;
          text-align: center;
        }

        // width: 280px;
        border-radius: 8px;

        .van-dialog__content {
          .van-dialog__message {
            font-size: 16px;
            padding: 15px 0 24px;
            height: 24px;
            line-height: 24px;
          }
        }
      }
    }

    .van-number-keyboard__body {
      background-color: #f5f6f7;
      padding: 12px 12px 30px;

      .van-hairline.van-key {
        background-color: #fff;
        width: calc(33.33333333% - 7.3333333px);
        height: 47px;
        border-radius: 4px;
        box-sizing: border-box;

        &:nth-child(3n+2) {
          margin: 0px 11px;
        }

        &:nth-child(n+1):nth-child(-n+9) {
          margin-bottom: 8px;
        }

        &:nth-child(10) {
          width: 0;
        }

        &:nth-child(11) {
          width: calc(66.6666666% - 3.666666px);
          margin-left: 0;
        }
      }

      .van-key--delete {
        position: relative;

        .delete {
          width: 25px;
          height: 16px;
          position: absolute;
          top: 35%;
          left: 50%;
          transform: translate(-50%);
        }
      }

    }

    .van-password-input {
      li {
        box-shadow: 0px 0px 4px 0px rgba(249, 89, 27, 0.24);
        border: 1px solid #e5e5e5;
        // border: 1px solid #E5E5E5; 
        border-radius: 5px;

        .van-password-input__cursor {
          background-color: #fc740c;
          height: 47%;
        }
      }
    }

    .van-number-keyboard {
      padding-bottom: 0px;
    }

    .passwordBox-title {
      position: relative;

      .center {
        margin: 15px auto;
        display: flex;
        align-items: center;
        width: fit-content;

        img {
          width: 20px;
          height: 15px;
          margin-right: 6px;
        }

        p {
          font-size: 16px;
          color: #333333;
          line-height: 26px;
        }
      }

      .icon {
        width: 22px;
        height: 22px;
        position: absolute;
        top: 2px;
        right: 13px;
      }
    }

    .forget_paasword {
      font-size: 12px;
      color: #999999;
      height: 19px;
      line-height: 19px;
      margin: 9px 19px 9px 0;
      text-align: right;
    }

    .van-popup {
      // 12 + 47*4 + 3*8 +30
      padding-bottom: 254px;
    }

  }
</style>